import { put, call } from 'redux-saga/effects';
import { questionnaireEvaluationGetOutcomeSuccessAction, questionnaireEvaluationFailureAction } from '../actions';
import { QuestionnaireEvaluationQuestionService } from '../services';
export function* questionnaireEvaluationGetQuestionaireOutcomeSaga(action, 
/*istanbul ignore next*/
questionnaireEvaluationQuestionsService = QuestionnaireEvaluationQuestionService.getInstance()) {
    try {
        const questionnaireEvaluationQuestionData = yield call({
            context: questionnaireEvaluationQuestionsService,
            fn: questionnaireEvaluationQuestionsService.questionnaireEvaluationGetQuestionaireOutcome
        }, action.payload);
        yield put(questionnaireEvaluationGetOutcomeSuccessAction(questionnaireEvaluationQuestionData));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationGetQuestionaireOutcomeSaga.js.map